import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Halogen$dVDom$dMachine from "../Halogen.VDom.Machine/index.js";
import * as Halogen$dVDom$dUtil from "../Halogen.VDom.Util/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Web$dEvent$dEventTarget from "../Web.Event.EventTarget/index.js";
const $ElemRef = (tag, _1) => ({tag, _1});
const $Prop = (tag, _1, _2, _3) => ({tag, _1, _2, _3});
const Created = value0 => $ElemRef("Created", value0);
const Removed = value0 => $ElemRef("Removed", value0);
const Attribute = value0 => value1 => value2 => $Prop("Attribute", value0, value1, value2);
const Property = value0 => value1 => $Prop("Property", value0, value1);
const Handler = value0 => value1 => $Prop("Handler", value0, value1);
const Ref = value0 => $Prop("Ref", value0);
const removeProperty = (key, el) => {
  const v = Halogen$dVDom$dUtil.hasAttribute(Data$dNullable.null, key, el);
  if (v) { return Halogen$dVDom$dUtil.removeAttribute(Data$dNullable.null, key, el); }
  if (Foreign.typeOf(Halogen$dVDom$dUtil.unsafeGetAny(key, el)) === "string") { return Halogen$dVDom$dUtil.unsafeSetAny(key, "", el); }
  if (key === "rowSpan") { return Halogen$dVDom$dUtil.unsafeSetAny(key, 1, el); }
  if (key === "colSpan") { return Halogen$dVDom$dUtil.unsafeSetAny(key, 1, el); }
  return Halogen$dVDom$dUtil.unsafeSetAny(key, Halogen$dVDom$dUtil.jsUndefined, el);
};
const propToStrKey = v => {
  if (v.tag === "Attribute") {
    if (v._1.tag === "Just") { return "attr/" + v._1._1 + ":" + v._2; }
    return "attr/:" + v._2;
  }
  if (v.tag === "Property") { return "prop/" + v._1; }
  if (v.tag === "Handler") { return "handler/" + v._1; }
  if (v.tag === "Ref") { return "ref"; }
  $runtime.fail();
};
const propFromString = Unsafe$dCoerce.unsafeCoerce;
const propFromNumber = Unsafe$dCoerce.unsafeCoerce;
const propFromInt = Unsafe$dCoerce.unsafeCoerce;
const propFromBoolean = Unsafe$dCoerce.unsafeCoerce;
const functorProp = {
  map: v => v1 => {
    if (v1.tag === "Handler") {
      return $Prop(
        "Handler",
        v1._1,
        x => {
          const $0 = v1._2(x);
          if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", v($0._1)); }
          return Data$dMaybe.Nothing;
        }
      );
    }
    if (v1.tag === "Ref") {
      return $Prop(
        "Ref",
        x => {
          const $0 = v1._1(x);
          if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", v($0._1)); }
          return Data$dMaybe.Nothing;
        }
      );
    }
    return v1;
  }
};
const functorElemRef = {
  map: v => v1 => {
    if (v1.tag === "Created") { return $ElemRef("Created", v(v1._1)); }
    if (v1.tag === "Removed") { return $ElemRef("Removed", v(v1._1)); }
    $runtime.fail();
  }
};
const buildProp = emit => el => {
  const haltProp = state => {
    const v = Foreign$dObject._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, "ref", state.props);
    if (v.tag === "Just" && v._1.tag === "Ref") {
      const $0 = v._1._1($ElemRef("Removed", el));
      if ($0.tag === "Just") { return emit($0._1)(); }
    }
  };
  const applyProp = events => (v, v1, v2) => {
    if (v2.tag === "Attribute") {
      const $0 = v2._2;
      const $1 = v2._3;
      const $2 = (() => {
        if (v2._1.tag === "Nothing") { return Data$dNullable.null; }
        if (v2._1.tag === "Just") { return Data$dNullable.notNull(v2._1._1); }
        $runtime.fail();
      })();
      Halogen$dVDom$dUtil.setAttribute($2, $0, $1, el);
      return v2;
    }
    if (v2.tag === "Property") {
      const $0 = v2._1;
      const $1 = v2._2;
      Halogen$dVDom$dUtil.unsafeSetAny($0, $1, el);
      return v2;
    }
    if (v2.tag === "Handler") {
      if (Halogen$dVDom$dUtil.unsafeHasAny(v2._1, events)) {
        const $0 = Halogen$dVDom$dUtil.unsafeGetAny(v2._1, events)._2;
        $0.value = v2._2;
        return v2;
      }
      const ref = {value: v2._2};
      const listener = Web$dEvent$dEventTarget.eventListener(ev => () => {
        const f$p = ref.value;
        const $0 = f$p(ev);
        if ($0.tag === "Just") { return emit($0._1)(); }
      })();
      Halogen$dVDom$dUtil.unsafeSetAny(v2._1, Data$dTuple.$Tuple(listener, ref), events);
      Halogen$dVDom$dUtil.addEventListener(v2._1, listener, el);
      return v2;
    }
    if (v2.tag === "Ref") {
      const $0 = v2._1($ElemRef("Created", el));
      if ($0.tag === "Just") { emit($0._1)(); }
      return v2;
    }
    $runtime.fail();
  };
  const patchProp = (state, ps2) => {
    const events = {};
    const $0 = state.events;
    const props = Halogen$dVDom$dUtil.diffWithKeyAndIxE(
      state.props,
      ps2,
      propToStrKey,
      (v, v1, v11, v2) => {
        if (v11.tag === "Attribute") {
          if (v2.tag === "Attribute") {
            if (v11._3 === v2._3) { return v2; }
            const $1 = (() => {
              if (v2._1.tag === "Nothing") { return Data$dNullable.null; }
              if (v2._1.tag === "Just") { return Data$dNullable.notNull(v2._1._1); }
              $runtime.fail();
            })();
            Halogen$dVDom$dUtil.setAttribute($1, v2._2, v2._3, el);
          }
          return v2;
        }
        if (v11.tag === "Property") {
          if (v2.tag === "Property") {
            if (Halogen$dVDom$dUtil.refEq(v11._2, v2._2)) { return v2; }
            if (v2._1 === "value" && Halogen$dVDom$dUtil.refEq(Halogen$dVDom$dUtil.unsafeGetAny("value", el), v2._2)) { return v2; }
            Halogen$dVDom$dUtil.unsafeSetAny(v2._1, v2._2, el);
          }
          return v2;
        }
        if (v11.tag === "Handler" && v2.tag === "Handler") {
          const $1 = v2._2;
          const $2 = v2._1;
          const handler = Halogen$dVDom$dUtil.unsafeGetAny($2, $0);
          const $3 = handler._2;
          $3.value = $1;
          Halogen$dVDom$dUtil.unsafeSetAny($2, handler, events);
        }
        return v2;
      },
      (v, v1) => {
        if (v1.tag === "Attribute") {
          const $1 = v1._2;
          const $2 = (() => {
            if (v1._1.tag === "Nothing") { return Data$dNullable.null; }
            if (v1._1.tag === "Just") { return Data$dNullable.notNull(v1._1._1); }
            $runtime.fail();
          })();
          return Halogen$dVDom$dUtil.removeAttribute($2, $1, el);
        }
        if (v1.tag === "Property") {
          const $1 = v1._1;
          return removeProperty($1, el);
        }
        if (v1.tag === "Handler") {
          const $1 = v1._1;
          const $2 = Halogen$dVDom$dUtil.unsafeGetAny($1, $0)._1;
          return Halogen$dVDom$dUtil.removeEventListener($1, $2, el);
        }
        if (v1.tag === "Ref") { return; }
        $runtime.fail();
      },
      applyProp(events)
    );
    return Halogen$dVDom$dMachine.$Step$p(undefined, {events, props}, patchProp, haltProp);
  };
  return ps1 => {
    const events = {};
    const ps1$p = Halogen$dVDom$dUtil.strMapWithIxE(ps1, propToStrKey, applyProp(events));
    return Halogen$dVDom$dMachine.$Step$p(undefined, {events, props: ps1$p}, patchProp, haltProp);
  };
};
export {
  $ElemRef,
  $Prop,
  Attribute,
  Created,
  Handler,
  Property,
  Ref,
  Removed,
  buildProp,
  functorElemRef,
  functorProp,
  propFromBoolean,
  propFromInt,
  propFromNumber,
  propFromString,
  propToStrKey,
  removeProperty
};
